import { useEffect, useContext, useState} from 'react';
import { RootStoreContext } from './stores/RootStore';
import StudentResponse from './features/StudentResponse';
import AppMain from "./features/AppMain";
import NotFound from "./layout/NotFound";
import  Loading  from "./utils/Loading";
import { useLocation } from "react-router-dom";
import { IMenuTree, IMenuChild } from './models/General';

const App = () => {

  const rootStore = useContext(RootStoreContext);
  const [authenticated, isAuthenticated] = useState(false);
  const [menuTreeList, setMenuTreeList] = useState<IMenuTree[]>([]) 
  const [menuChildList, setMenuChildList] = useState<IMenuChild[]>([]) 
  const [list, setList] = useState<any>() 
  const [level, setLevel] = useState("") 
  const [loadApp, isLoadApp] = useState(false);
  const [student, setStudent] = useState(false);
  const {profile,menuTree} = rootStore.authenticationStore;
  const { dashboard} = rootStore.commonStore; 
  const location = useLocation();
  const search = location.search;
  const error=new URLSearchParams(search).get("error");
  const res=new URLSearchParams(search).get("res");  

  useEffect(() => {  

    const paths = location.pathname.split("/");    

    if (paths[1] === 'student') {
      setStudent(true)
    }
    else if (error === 'email') {
      isLoadApp(true)
    }
    else if (res === 'out') {
      isLoadApp(true)
    }
    else
    {
      setTimeout(() => {
        // local test, need to edit localhost cookie manually
        // let cookie = '0c2e4c28f92c2d8939fe90758d52be34f7e2e5e2783111b8a6c2e5aae42cfb84a%3A2%3A%7Bi%3A0%3Bs%3A11%3A%22CookieYokai%22%3Bi%3A1%3Bs%3A32%3A%22cCA-9DBvNjXCrwXXUynB2INaIwpk_Owh%22%3B%7D'
      
        let cookie = '';
        const cookieName = 'CookieYokai';
        const theCookie = '' + document.cookie;
        // console.log(theCookie)
        const ind = theCookie.indexOf(cookieName);
        let ind1 = theCookie.indexOf(';', ind);
        if (ind1 === -1) ind1 = theCookie.length;
        if (ind === -1) cookie = '';
        cookie = unescape(theCookie.substring(ind + cookieName.length + 1, ind1));
        // console.log(cookie)
        if(cookie !== ''){
          cookie = cookie.replace(/['"]+/g, '');
          // console.log(cookie)
          cookie = cookie.substring(cookie.indexOf('{', 0));
          // console.log(cookie)
          cookie = cookie.substring(1, cookie.length);
          // console.log(cookie)
          cookie = cookie.substring(0, cookie.length - 1);
          // console.log(cookie)
          let token = cookie.split(';').map(item => {
            return item.split(':');
          });
          // console.log(token)

          if(typeof token[3] != 'undefined'){
            if(typeof token[3][2] != 'undefined'){
              // console.log('you arrived')
              let checkToken = token[3][2]
              // console.log(checkToken)
              const data = profile(String(checkToken));
              data.then(function(result) {
                if(result.status==="200"){
                  isAuthenticated(true)
                  window.localStorage.setItem('emplid', String(result.result[0]['EMPLID']));
                  window.localStorage.setItem('levelid', String(result.result[0]['LEVEL_ID']));
                  window.localStorage.setItem('name', String(result.result[0]['NAMA']));

                  const dataMenu = menuTree(String(result.result[0]['EMPLID']));
                  dataMenu.then(function(result) {
                    console.log(result);
                    setMenuTreeList(result.result);
                    setMenuChildList(result.allowed_url);
                  })

                  const report = dashboard(String(result.result[0]['LEVEL_ID']), String(result.result[0]['EMPLID']));
                  report.then(function(result) {
                    setList(result)
                  })

                  setLevel(String(result.result[0]['LEVEL_ID']))
                  window.localStorage.setItem('token', checkToken );
                }
                else{
                  isLoadApp(true)
                }
              })
            }
            else{
              // console.log('cookie token [3][2] not found')
              isLoadApp(true)
            }
          }
          else{
            // console.log('cookie token [3] not found')
            isLoadApp(true)
          }

        }
        else{
          // console.log('cookie not found')
          isLoadApp(true)
        }
        
        //The old ways
        /*
        let checkToken = window.localStorage.getItem('token');
        // checkToken = 'M3fGm2DYmP1Z_Z5K0t6QIb9NtGzoeCZR'
        console.log(checkToken)
        
        if(res !== null && String(res) !== '' ){
          if(res === 'out'){
            isLoadApp(true)
          }
          else{
            window.localStorage.setItem('token', String(res));
            checkToken = res
            
            // test local
            // window.location.href = "http://localhost:3000";

            //prod
            window.location.href = "https://academic.umn.ac.id";
            
          }
          console.log("res not null")
        }else{
          console.log("res null")
            
            console.log(checkToken)
            if(checkToken === null || String(checkToken) == ''){
              console.log("token null")
              // test local
              // window.location.href = "http://localhost:3000/?res=QRG03MlkhOLNuF1Mh7bBRS_Od99Ct0fu";

              //prod
              window.location.href = "https://academic.umn.ac.id/api/academic/user/login";
            }
        }

        isAuthenticated(true)
        const data = profile(String(checkToken));
        data.then(function(result) {
          console.log(result.status)
          if(result.status==="200"){
            isAuthenticated(true)
            window.localStorage.setItem('emplid', String(result.result[0]['EMPLID']));
            window.localStorage.setItem('levelid', String(result.result[0]['LEVEL_ID']));
            window.localStorage.setItem('name', String(result.result[0]['NAMA']));

            const dataMenu = menuTree(String(result.result[0]['EMPLID']));
            dataMenu.then(function(result) {
              setMenuTreeList(result);
            })

            const report = dashboard(String(result.result[0]['LEVEL_ID']), String(result.result[0]['EMPLID']));
            report.then(function(result) {
              setList(result)
            })

            setLevel(String(result.result[0]['LEVEL_ID']))
          }
        }) 
        */

      }, 1000)
    }

  }, []);

  if(student){
    return <StudentResponse/>
  }else{
    if (authenticated) {
      return <AppMain dataMenu={menuTreeList} allowedUrl={menuChildList} report={list} level={level}/>
    } else {
      if(loadApp){
        return <NotFound/>
      }else{
        return <Loading/>
      }
    }
  }
}

export default App;
